import React from 'react'
import { ReactComponent as AccountActiveIcon } from '@svgs/menu-account-active.svg'
import { ReactComponent as AccountIcon } from '@svgs/menu-account.svg'
import styles from './styles.module.scss'

export const AccountMenuIcon = ({ isLoggedIn }: { isLoggedIn: boolean }) => {
  return (
    <span
      className={`${styles.accountMenuIcon} ${
        styles[isLoggedIn ? 'loggedIn' : '']
      }`}
    >
      {isLoggedIn ? (
        <AccountActiveIcon width={23} height={23} />
      ) : (
        <AccountIcon width={23} height={23} />
      )}
    </span>
  )
}

export default AccountMenuIcon
